export default function Card({ children, className = '', ...props }) {
  return (
    <div
      className={`bg-white rounded-2xl shadow-sm border border-slate-200/60 overflow-hidden ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}
